import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Confirme seu e-mail',
  sentLinkLead: 'Enviamos um link de confirmação para ',
  sentLinkTail: '. Assim que confirmar, você pode entrar no Bodyprint Partners.',
  goToSignIn: 'Ir para o login',
} satisfies TranslationTree;
